var api_url = "https://api-dev.mylola.com/api/v1";

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? event.target.classList.add("hidden") : "";
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    this.querySelectorAll(".popup-modal__close").forEach((btn) => {
      btn.addEventListener("click", this.hide.bind(this, false));
    });

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model"))
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    if (this.querySelector('[role="dialog"]')) {
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    //UpCart overlay
    if (document.querySelector(".cart_overlay")) {
      document.querySelector(".cart_overlay").classList.add("hide");
    }
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
      // if (button.classList.contains('assortment--btn'))
      //   this.setCustomizeDefault();
    });
  }

  setCustomizeDefault() {
    this.customizeContainer = document.querySelector(".assortment--customizer");
    const { maxCount, suffix } = {
      maxCount: this.customizeContainer.dataset.totalCount,
      suffix: this.customizeContainer.dataset.totalSuffix,
    };

    this.customizeContainer.querySelector(
      ".custom-total"
    ).textContent = `<span class="custom-current-qty">${maxCount}</span> / ${maxCount} ${suffix}`;

    this.customizeContainer
      .querySelectorAll('.assortment__wrapper .options input[type="number"]')
      .forEach((inputNumberEl) => {
        inputNumberEl.value = inputNumberEl.dataset.value;
      });

    this.customizeContainer.querySelectorAll(".save-button").forEach((saveButtonElement) => {
      saveButtonElement.textContent = `Save`;
      saveButtonElement.removeAttribute("disabled", "disabled");
    });

    const newBox = Array.from(
      this.customizeContainer.querySelectorAll('.assortment__wrapper .options input[type="number"]')
    )
      .map((inputNumberEl) => {
        let result = "";
        for (var i = 0; i < inputNumberEl.dataset.value; i++) {
          result += `<li  class="${inputNumberEl.dataset.productType}" style="background-color: ${inputNumberEl.dataset.color}"></li>`;
        }

        return result;
      })
      .join("");

    this.customizeContainer.querySelector(".assortment__variants").innerHTML = newBox;

    this.customizeContainer.querySelectorAll(".plus").forEach((plusButtonElement) => {
      plusButtonElement.setAttribute("disabled", "disabled");
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.hasAbsorbencyVariantFromShopify = false;
    if (this.querySelector('fieldset[data-recharge-absorbency="true"]')) {
      this.hasAbsorbencyVariantFromShopify = true;
      const atcButtonWrapper = document.querySelector(".product-form__buttons");
      atcButtonWrapper.addEventListener("click", this.warningMessageHandler);
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    if (this.hasAbsorbencyVariantFromShopify) {
      this.updateRechargeSubscriptionVariant();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      this.addWarningMessage();
    } else {
      this.removeWarningMessage();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  warningMessageHandler() {
    const atcButton = document.querySelector(".product-form__buttons button");
    if (!document.querySelector(".custom-warning-copy")) {
      const warning = document.createElement("span");
      warning.classList.add("custom-warning-copy");
      warning.innerHTML = "Please select an absorbency.";

      insertAfter(warning, atcButton);
      document.querySelector(
        ".product-form__buttons .product-form__submit.button.button--full-width"
      ).style.zIndex = 0;
    }
  }

  removeWarningMessage() {
    if (this.hasAbsorbencyVariantFromShopify) {
      const atcButtonWrapper = document.querySelector(".product-form__buttons");
      atcButtonWrapper.removeEventListener("click", this.warningMessageHandler);
      if (document.querySelector(".custom-warning-copy")) {
        document.querySelector(".custom-warning-copy").remove();
      }
    }
  }
  addWarningMessage() {
    if (this.hasAbsorbencyVariantFromShopify) {
      const atcButtonWrapper = document.querySelector(".product-form__buttons");
      atcButtonWrapper.addEventListener("click", this.warningMessageHandler);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = productForm.querySelector('[name="add"]');
    if (addButton.dataset.subscriptionType == "new" || addButton.dataset.subscriptionType == "edit")
      return;

    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      let input = productForm.querySelector('input[name="id"]');
      if (!input) {
        input = productForm.querySelector("input#variant_id");
      }
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    if (!window.location.href.includes("/tools/recurring/portal")) {
      const pickUpAvailability = document.querySelector("pickup-availability");
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        // Also update title price if it exists (for dynamic pricing in title block)
        const titlePriceDestination = document.getElementById(`title-price-${this.dataset.section}`);
        const titlePriceSource = html.getElementById(
          `title-price-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        if (titlePriceSource && titlePriceDestination) titlePriceDestination.innerHTML = titlePriceSource.innerHTML;

        // Update loyalty points hidden price element for LoyaltyLion
        const lionPriceElement = document.querySelector(`[data-lion-price-for-product-id]`);
        if (lionPriceElement && this.currentVariant && this.currentVariant.price) {
          const priceFormatted = "$" + parseFloat(this.currentVariant.price / 100).toFixed(2);
          lionPriceElement.innerText = priceFormatted;
          
          // Trigger LoyaltyLion refresh if available
          try {
            if (window.loyaltylion && loyaltylion.ui && typeof loyaltylion.ui.refresh === 'function') {
              loyaltylion.ui.refresh();
            }
          } catch (e) {
            console.warn('[LoyaltyLion] Refresh failed during variant change:', e);
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      if (addButton.getAttribute("has_absorbency_variant_from_shopify") === "true") {
        console.log("t1");
        customHelper();
      } else {
        console.log("t2");
        addButton.removeAttribute("disabled");
      }

      if (addButton.dataset.subscriptionType == "new") {
        addButtonText.textContent = "Add to Subscription";
      } else if (addButton.dataset.subscriptionType == "edit") {
        addButtonText.textContent = "Update Subscription";
      } else {
        if (addButton.dataset.isPreorder == "true") {
          addButtonText.textContent = window.variantStrings.preorder;
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateRechargeSubscriptionVariant() {
    const selectedVariantTitle = this.querySelector(
      'fieldset[data-recharge-absorbency="true"] input:checked'
    ).value;

    console.log(selectedVariantTitle);

    //update the variant for subscription(rc)
    if (document.querySelector(`#rc_container #rc_duplicate_selector`)) {
      //update go with your flow variant
      let subscription_goFlow_options = document.querySelectorAll(
        "#rc_container #rc_duplicate_selector option.rc_subscription_goFlow_variant_id"
      );

      subscription_goFlow_options.forEach((each) => {
        if (
          each.getAttribute("data-title") &&
          each.getAttribute("data-title") == selectedVariantTitle
        ) {
          document.querySelector(
            `#rc_container #rc_duplicate_selector option.go_with_your_flow.rc_subscription_variant_id`
          ).value = each.value;
        }
      });

      //update delivery 3 month and 6 month variant
      let subscription_ids_json = document.querySelectorAll(
        '#rc_container [type="application/json"][subscription_variant]'
      );
      if (subscription_ids_json.length > 0) {
        subscription_ids_json.forEach((each) => {
          let variantData = JSON.parse(each.textContent);

          let newSubscriptionVariantId = variantData.find((v) => v.title == selectedVariantTitle);

          let index = each.getAttribute("index");
          let option = document.querySelector(
            `#rc_container #rc_duplicate_selector option.rc_subscription_variant_id.index_${index}`
          );
          option.value = newSubscriptionVariantId.id;
          option.textContent = newSubscriptionVariantId.id;
        });
      }
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class LolaScrollSlide extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector(".animated-cards");
    //this.parentElement = this.container.parentElement;
    this.cards = this.parentElement.querySelectorAll(".card");
    this.cardsLength = this.cards.length;
    this.containerTop = this.getTopOffset();
    this.cardOpacities = [];
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.topValueSet = !1;
    this.parentElement.style.height = "calc(".concat(100 * this.cardsLength, "vh + 50px");
    this.parentElement.style.position = "relative";

    this.bindEvents();
  }

  bindEvents() {
    var t = this;
    document.addEventListener("scroll", function () {
      t.handleBodyScroll();
    });
  }

  getTranslateDistance(t) {
    var e = this.cardOpacities[this.activeIndex] || 0,
      n = (t - this.activeIndex + 1) * this.screenWidth - this.screenWidth * e;
    return "translateX(".concat(n, "px)");
  }

  bezierBlend(t) {
    return t * t * (3 - 2 * t);
  }

  getOpacity(t) {
    var e = this.cardOpacities[t] || 0,
      n = this.bezierBlend(e);
    return this.round(n, 2);
  }

  getTopOffset() {
    return this.container.getBoundingClientRect().top + window.scrollY;
  }

  inView(t, e, n, r) {
    return n + t >= e && n <= e + t * r;
  }

  round(t, e) {
    return parseFloat(t.toFixed(e));
  }

  handleBodyScroll() {
    var t = this,
      e = this.getTopOffset();

    if (
      (e > scrollY && !this.topValueSet && ((this.containerTop = e), (this.topValueSet = !0)),
      this.inView(this.screenHeight, this.containerTop, scrollY, this.cardsLength))
    ) {
      var n,
        r,
        o = scrollY - this.containerTop;
      if (o <= 0)
        (n = this.screenHeight + o),
          (this.activeIndex = 0),
          (r = n / this.screenHeight),
          (this.cardOpacities[this.activeIndex] = this.round(r, 5));
      else {
        r = o / this.screenHeight;
        var l = Math.floor(r);
        if (l >= this.cardsLength - 1) return;
        (this.activeIndex = l + 1), (this.cardOpacities[this.activeIndex] = this.round(r - l, 5));
      }
      requestAnimationFrame(function () {
        t.cards.forEach(function (e, n) {
          var r = e.querySelector(".card__background"),
            content = e.querySelector(".content"),
            o = t.getOpacity(n);
          (r.style.opacity = o),
            content && (content.style.transform = t.getTranslateDistance(n)),
            0 === t.activeIndex && t.cards[0].classList.add("active"),
            1 === t.activeIndex &&
              (t.getOpacity(t.activeIndex) > 0.4
                ? t.cards[0].classList.remove("active")
                : t.cards[0].classList.add("active"));
        });
      });
    }
  }
}

customElements.define("lola-scroll-slider", LolaScrollSlide);

if (document.getElementById("grnhse_iframe")) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const jobId = urlParams.get("gh_jid");
  if (jobId) {
    document.getElementById(
      "grnhse_iframe"
    ).src = `https://boards.greenhouse.io/embed/job_app?for=lola&token=${jobId}&b=https%3A%2F%2Fmylola.com%2Fjobs`;
    document.getElementById("grnhse_iframe").height = "2311";
  }
}

function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

(function mylola_j6122_6559v1() {
  if (
    document.querySelectorAll('.sub-item a[href*="applicator-tampons"]').length &&
    !document.querySelectorAll(".mylola_j6122_6559v1").length
  ) {
    changeLabels();
    document.body.classList.add("mylola_j6122_6559v1");
  } else if (!document.querySelectorAll(".mylola_j6122_6559v1").length) {
    requestAnimationFrame(mylola_j6122_6559v1);
  }

  function changeLabels() {
    var subMenus = document.querySelectorAll('.sub-item a[href*="applicator-tampons"]');
    if (subMenus.length) {
      subMenus.forEach(function (link) {
        var txt = link.textContent;
        if (txt) {
          if (txt.indexOf("Customizable: ") > -1) {
            link.innerHTML = txt.replace(
              "Customizable: ",
              '<span class="v_badgeLabel v_customizeLink">Customizable</span>'
            );
          }
          if (txt.indexOf("Grab & Go: ") > -1) {
            link.innerHTML = txt.replace(
              "Grab & Go: ",
              '<span class="v_badgeLabel v_grabLink">Grab & Go</span>'
            );
          }
        }
      });
    }
  }
})();

function customHelper() {
  const activeSubscriptionWrapper = document.querySelector(
    ".custom_rc_payment_options_wrapper .selected-option.active"
  );

  const activeOTPWrapper = document.querySelector(
    ".rc_block__type__onetime.subscription-type-selector.rc_block__type--active"
  );

  const atcButton = document.querySelector(
    `${
      window.location.href.includes("/collections") ? ".custom-quick-view-product " : ""
    } .product-form__buttons button`
  );

  console.log(atcButton);

  console.log(atcButton.getAttribute("disabled") === "disabled");

  if (
    (activeSubscriptionWrapper || activeOTPWrapper) &&
    atcButton.getAttribute("disabled") === "disabled"
  ) {
    console.log("Active subscription wrapper is present.");

    let hasAbsorbencyVariantFromShopify = false;
    if (document.querySelector('fieldset[data-recharge-absorbency="true"]')) {
      hasAbsorbencyVariantFromShopify = true;
      const atcButtonWrapper = document.querySelector(".product-form__buttons");
      atcButtonWrapper.addEventListener("click", this.warningMessageHandler);
    }

    if (hasAbsorbencyVariantFromShopify) {
      console.log("test1");
      const selectedVariantTitle = document.querySelector(
        'variant-radios fieldset[data-recharge-absorbency="true"] input:checked'
      )?.value;
      console.log("selectedVariantTitle: ", selectedVariantTitle);
      if (selectedVariantTitle) {
        atcButton.removeAttribute("disabled");
        atcButton.querySelector("span").innerHTML = "Add to cart";
      }
    } else {
      if (activateAtcGlobally) {
        console.log("test2");
        console.log("activateAtcGlobally: ", activateAtcGlobally);
        atcButton.removeAttribute("disabled");
        atcButton.querySelector("span").innerHTML = "Add to cart";
      }
    }
  }
}

/**
 * Adds a mutation observer for a specific selector to become available then executes the callback.
 * @param selector
 * @param callback
 */
function onElementAvailable(selector, callback) {
  const observer = new MutationObserver(mutations => {
    if (document.querySelector(selector)) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

/**
 * Waits for the first element with the given class to appear in the DOM, then runs the callback.
 * @param {string} className - Class name or selector (with or without leading dot)
 * @param {(el: Element) => void} callback - Function to run when the element is available
 */
function waitForElementByClass(className, callback) {
  const selector = className.charAt(0) === "." ? className : `.${className}`;

  const existing = document.querySelector(selector);
  if (existing) {
    callback(existing);
    return;
  }

  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Add accessibility attributes to items that are injected via Thirdparty extensions
waitForElementByClass('upcart-header-text', (el) => {
  el.removeAttribute('aria-label');

  const miniCartContainer = document.querySelector('#CartPopup');
  if (miniCartContainer) {
    miniCartContainer.setAttribute('role', 'dialog');
    miniCartContainer.setAttribute('aria-modal', 'true');
    miniCartContainer.setAttribute('aria-label', 'Cart');
  }
});

window.addEventListener("DOMContentLoaded", (event) => {
  const salePrices = [...document.querySelectorAll(".price[plp-custom-price] span.line-through")];
  salePrices.forEach((price) => {
    const saleBadge = document.createElement("span");
    saleBadge.classList.add("custom-sale-badge-plp");
    saleBadge.innerHTML = "Sale";
    // price.closest("[plp-custom-price]").appendChild(saleBadge);
  });

  const productCardHeight = document.querySelector(".product--image")?.offsetHeight;

  const quickAddPanels = [...document.querySelectorAll(".quick-add-panel")];

  const currentURL = window.location.href;

  if (currentURL === "https://mylola.com/" || currentURL.includes("/collections") || currentURL.includes("/search")) {
    quickAddPanels.forEach((panel) => {
      panel.style.top = `${productCardHeight - 50}px`;
    });
  }
  
  // Reduce the z-index of smile-ui-container to prevent overlap of checkout button on mobile
  onElementAvailable('#smile-ui-container', () => {
    const smileContainer = document.querySelector('#smile-ui-container');
    if (smileContainer) {
      smileContainer.style.zIndex = 500;
    }
  });
});
